import instance from '@/api/instance'

export default {
  countNewsLetter: () => {
    return instance.get('/admin/newsletter/count')
  }
}
